"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { showToast, TOAST_TYPES } from "@/lib/toast-utils/toast.util";
import { OAUTH_PROVIDERS, OAuthProvider } from "./oauth.constants";
import { cn } from "@/lib/utils/utils";

interface OAuthButtonsProps {
  dividerText?: string;
  showDivider?: boolean;
  className?: string;
  actionText?: string; // e.g. "ログイン" or "サインアップ"
}

export const OAuthButtons: React.FC<OAuthButtonsProps> = ({
  dividerText = "または",
  showDivider = true,
  className,
  actionText = "ログイン",
}) => {
  const handleOAuthClick = (provider: OAuthProvider) => {
    showToast(TOAST_TYPES.info, provider.message);
  };

  return (
    <div className={cn("w-full space-y-4", className)}>
      {showDivider && (
        <div className="relative my-4">
          <div className="absolute inset-0 flex items-center">
            <span className="w-full border-t border-border" />
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-card px-3 text-muted-foreground font-medium">
              {dividerText}
            </span>
          </div>
        </div>
      )}

      <div className="grid grid-cols-3 gap-3">
        {OAUTH_PROVIDERS.map((provider) => {
          const Icon = provider.icon;
          return (
            <Button
              key={provider.id}
              type="button"
              variant="outline"
              className="h-11 w-full flex items-center justify-center rounded-lg border border-border hover:bg-accent/70 hover:border-muted-foreground/30 transition-all duration-200 active:scale-95 shadow-xs cursor-pointer"
              onClick={() => handleOAuthClick(provider)}
              aria-label={`${provider.name}で${actionText}`}
              title={`${provider.name}で${actionText}`}
            >
              <Icon className="h-5 w-5" />
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default OAuthButtons;
